import { ProviderFeeInvoiceRecord } from "models/view-models/providers/provider-fee-invoice-record";
import { QUERY_KEYS } from "data/data-access-hooks/query-keys";
import { ServiceResponse } from "andculturecode-javascript-core";
import { useQuery } from "@tanstack/react-query";
import { t } from "utilities/localization/t";
import { ListProviderFeeInvoicesQueryParams } from "utilities/services/providers/provider-fee-invoice-service";

export const useGetProviderFeeInvoiceList = (
    queryFn: (params?: ListProviderFeeInvoicesQueryParams) => Promise<ServiceResponse<ProviderFeeInvoiceRecord>>,
    providerId?: number,
    year?: number
) =>
    useQuery({
        queryKey: [QUERY_KEYS.PROVIDER_FEE_INVOICE_LIST, { providerId, year }],
        queryFn: async () => {
            const response = await queryFn({ providerId, year });
            if (
                response.status >= 400 ||
                response.result?.hasErrors() ||
                response.results?.hasErrors()
            ) {
                throw new Error(t("thereWasAProblemReturningEvents"));
            }
            return response.resultObjects;
        },
        staleTime: Infinity,
        retry: false,
        retryOnMount: false,
        refetchOnMount: false,
        enabled:
            providerId != null &&
            Number.isInteger(providerId) &&
            providerId > 0 &&
            year != null &&
            Number.isInteger(year) &&
            year > 0,
    });
